import React, {Component} from 'react'
import PasswordForget from '../../Authentication/UserPages/Password/PasswordForget'
import CancelAccount from "./CancelAccount"
import { Segment } from 'semantic-ui-react'
import ProfileDisplayHeader from "./ProfileDisplayHeader";
import InfoSegment from "../../SharedComponents/InfoSegment";
import API_Root_Lambda from "../../Constants/API_Root_Lambda";
import Loader from 'react-loader-spinner';

class GeneralIndex extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dataStorageRegion: <Loader
                type="TailSpin"
                color="black"
                height="10"
                width="10"
            />,
        };
    }

    componentDidMount(){
        this.loadDataStorageRegion();
    }

    loadDataStorageRegion = async () => {
        try {
            const email = localStorage.getItem("email");
            const token = localStorage.getItem("token");

            // If missing credentials, fall back to US (per requirement)
            if (!email || !token) return;

            const resp = await fetch(
                `${API_Root_Lambda}api/get-apispreadsheets-data-storage-region/`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ email, token }),
                }
            );

            if (!resp.ok) return;

            const json = await resp.json();
            const region = json.dataStorageRegion;

            if (region) {
                this.setState({ dataStorageRegion: String(region) });
            }
        } catch {
            // If the API request fails, region should remain "US"
        }
    };

    render() {
        return (
            <div>
                <div style={{marginBottom: "16px"}}>
                    <InfoSegment
                        header="Profile"
                        info={[{label: "Email", value: localStorage.getItem("email").toString()},
                                {label: "Account Created", value: this.props.dateJoined.toString()},
                                { label: "Data Storage Region", value: this.state.dataStorageRegion }
                            ]}
                    />
                </div>
                <div style={{marginBottom: "16px"}}>
                    <InfoSegment
                        header="Reset Password"
                        info={<PasswordForget profilePage/>}
                    />
                </div>
                {
                    this.props.pricingPlan === 'free' || this.props.pricingPlan === "" ?
                        <div style={{marginBottom: "16px"}}>
                            <InfoSegment
                                header="Delete Account"
                                info={<CancelAccount pricingPlan={this.props.pricingPlan}/>}
                            />
                        </div> : null
                }
            </div>
        )
    }
}


export default GeneralIndex